import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IoMdMail } from "react-icons/io";

const ACTIVATE_COPY = "We emailed you an Activate button. Open that email.";

const EmailSent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const stateObj = location?.state;
    const isSignup = ["club", "player", "guest"].includes(stateObj?.registerFor);
    const [timer, setTimer] = useState(isSignup ? 0 : 5);

    useEffect(() => {
        if (isSignup) {
            return undefined;
        }
        const interval = setInterval(() => {
            setTimer((prevCount) => {
                if (prevCount <= 1) {
                    clearInterval(interval);
                    navigate("/reset-password", { state: { userEmail: stateObj?.userEmail } });
                    return 0;
                }
                return prevCount - 1;
            });
        }, 1000);
        return () => clearInterval(interval);
    }, [isSignup, navigate, stateObj?.userEmail]);

    return (
        <div className="email_sent_container">
            <h4>{isSignup ? ACTIVATE_COPY : "We've Sent a Verification Code to Your Email"}</h4>
            <div className="email_sent_body">
                <IoMdMail style={{ fontSize: 150, paddingTop: 15, color: "var(--hoverColorBold)" }} />
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            {isSignup ? (
                <p className="email_sent_redirect" data-testid="email-sent-activate-copy">
                    Check your inbox, then <Link to="/login">sign in</Link> after you click Activate.
                </p>
            ) : (
                <h1 className="email_sent_redirect">Redirecting in {timer} s.......</h1>
            )}
        </div>
    );
};

export default EmailSent;
